import ServiceReports from '../../../../../services/ServiceCRUDFLEXCHAT';
//modificar quando o service relativo estiver pronto
class Service extends ServiceReports {
  constructor() {
    super('/relatorio/unificado');
  }
}

export default new Service();
